import axios from "axios";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ShowdatesModal from "../../Components/Common/Model/ShowdatesModal";
import ExperienceMap from "../../Components/Utility/ExperienceMap";
import ImageSlider from "../../Components/Utility/ImageSlider";
import ItineraryModal from "../../Components/Utility/ItineraryModal";
import ReviewSlider from "../../Components/Utility/ReviewSlider";

import { SetMetaTags } from "../../Components/Utility/setMetaTags";
import Sharepop from "../../Components/Utility/SharePop";
import TruncateText from "../../Components/Utility/TruncateText";
import LoginModal from "../Users/LoginModal";
import OtherInfo from "../Users/OtherInfo";

function ExperienceDetail() {
  const [showModal, setShowModal] = useState(false);
  const [experienceData, setExperienceData] = useState(null);
  const [cmsData, setCMSData] = useState(null);

  const [loading, setLoading] = useState(true);
  const { slug } = useParams();
 
   // ✅ Extract ID from slug
  const [loginOpen, setLoginOpen] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [showShare2, setShowShare2] = useState(false);
  const location = useLocation(); // Get the location state from the URL (if it exists)
  const { date } = location.state || {};
  const reviewSectionRef = useRef(null);
  const [showOtherInfoModal, setShowOtherInfoModal] = useState(false);

  const closeOtherInfo = () => {
    setShowOtherInfoModal(false);
  };

  const [itineraryModalOpen, setItineraryModalOpen] = useState(false);
  const [itineraryImages, setItineraryImages] = useState([]);
  const [selectedItineraryIndex, setSelectedItineraryIndex] = useState(0);

  const [price, setPrice] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [itinerary, setItinerary] = useState([]);
  const [itineraryLoading, setItineraryLoading] = useState(false);
  const [slots, setSlots] = useState([]);
  const [activeKey, setActiveKey] = useState(null);

  const [participantCount, setParticipantCount] = useState({
    adults: 1,
    children: 0,
    infants: 0,
  });

  const navigate = useNavigate();
  const [showShare, setShowShare] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const token = localStorage.getItem("authToken");
  const storedUser = localStorage.getItem("user");

  const toggleShare = (e) => {
    e.preventDefault();
    setShowShare((prev) => !prev);
  };

  const toggleShare2 = (e) => {
    e.preventDefault();
    setShowShare2((prev) => !prev);
  };

  // ✅ scroll function
  const handleScrollToReviews = () => {
    if (reviewSectionRef.current) {
      const header =
        document.querySelector("header") ||
        document.querySelector(".main-header");
      const headerHeight = header ? header.offsetHeight : 100;

      // Get the Y-position of the section relative to the entire page
      const elementTop =
        reviewSectionRef.current.getBoundingClientRect().top + window.scrollY;

      // ✅ Subtract header height and also internal padding (try 20–40px)
      const offsetPosition = elementTop - headerHeight - 30;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleMessageClick = async () => {
    if (!experienceData?.data) return;

    if (!token || !storedUser) {
      // toast.error("Please Login first");
      setLoginOpen(true);
      return;
    }
    const user = JSON.parse(storedUser);

    if (user && user.user_type !== 1) {
      toast.error("You are not allowed to chat Host");
      return;
    }

    try {
      // ✅ 1. Call the API to get experience_id
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/user/getUserBookingCount`,
        {
          experience_id: experienceData.data.experience_id, // or any required field
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      // ✅ 2. Check response and proceed only if success
      if (res.data?.status === true) {
        const totalBookings = res.data?.total_bookings || 0;

        if (totalBookings > 0) {
          // ✅ User has bookings — allow chat
          const hostData = {
            user_id: experienceData.data.user_id,
            first_name: experienceData.data.first_name,
            last_name: experienceData.data.last_name,
            email: experienceData.data.email,
            profile_image: experienceData.data.profile_pic,
          };

          navigate("/chat", { state: { chatTarget: hostData } });
        } else {
          // ❌ No bookings — show error
          toast.error("Please book this experience before starting a chat.");
        }
      } else {
        toast.error(
          res.data?.message || "Unable to start chat. Please try again."
        );
      }
    } catch (error) {
      const apiMessage =
        error.response?.data?.message ||
        "Something went wrong while processing the request.";
      toast.error(apiMessage);
    }
  };

  const fetchCmsHostDetails = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "host-things",
        }
      );

      setCMSData(res.data);
    } catch (err) {
      console.error("Error fetching experience details:", err);
    }
  };

  const handlePackageChange = async (pkg) => {
    setSelectedPackage(pkg);
    setItineraryLoading(true);

    try {
      const selectedCurrency =
        JSON.parse(localStorage.getItem("selectedCurrency"))?.id || "6";

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getHomeExperienceDetails/${slug}?currency_id=${selectedCurrency}&package_id=${pkg.id}`
      );

      setPrice(res.data);

      // ✅ Update only dynamic parts
      setItinerary(res.data.data.itinerary || []);
      // setSlots(res.data.data.slots || []);
      setSlots(res.data.data.slots || []);

      setParticipantCount({
        adults: Number(pkg.no_of_adult) > 0 ? 1 : 0, // Only prefill 1 if adults exist
        children: Number(pkg.no_of_childs) > 0 ? 0 : 0, // Only enable if children exist
        infants: Number(pkg.no_of_infant) > 0 ? 0 : 0, // Only enable if infants exist
      });
    } catch (err) {
      console.error("Error updating package data:", err);
    } finally {
      setItineraryLoading(false); // 🔹 Stop loader
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    fetchCmsHostDetails();
  }, [experienceData]);

  const handleCountChange = (type, action) => {
    setParticipantCount((prev) => {
      let updated = { ...prev };

      // Get limits from the package
      const maxAdult = Number(selectedPackage?.no_of_adult || 0);
      const maxChild = Number(selectedPackage?.no_of_childs || 0);
      const maxInfant = Number(selectedPackage?.no_of_infant || 0);

      // ✅ Decide controlling limit based on available type
      let totalLimit = 0;
      if (maxAdult > 0) totalLimit = maxAdult;
      else if (maxChild > 0) totalLimit = maxChild;
      else totalLimit = maxInfant;

      // ✅ Calculate combined totals
      const totalAll = prev.adults + prev.children + prev.infants;
      const totalChildInfant = prev.children + prev.infants;

      // --- Adults ---
      if (type === "adults") {
        if (action === "increment" && totalAll < totalLimit) {
          updated.adults += 1;
        } else if (action === "decrement" && prev.adults > 1) {
          updated.adults -= 1;
        }
      }

      // --- Children ---
      if (type === "children") {
        if (action === "increment" && totalAll < totalLimit) {
          updated.children += 1;
        } else if (action === "decrement" && prev.children > 0) {
          updated.children -= 1;
        }
      }

      // --- Infants ---
      if (type === "infants") {
        if (action === "increment" && totalAll < totalLimit) {
          updated.infants += 1;
        } else if (action === "decrement" && prev.infants > 0) {
          updated.infants -= 1;
        }
      }

      return updated;
    });
  };

  useEffect(() => {
    const fetchExperienceDetails = async (currencyId, packageId = "") => {
      try {
        const res = await axios.get(
          `${
            process.env.REACT_APP_API_BASE
          }/getHomeExperienceDetails/${slug}?date=${date || ""}&currency_id=${
            currencyId || "6"
          }${packageId ? `&package_id=${packageId}` : ""}`
        );
        setExperienceData(res.data);

        // ✅ All packages
        if (res.data?.all_packages?.length > 0) {
          setPackages(res.data.all_packages);

          // ✅ Find default package from "package" object in API
          const defaultPkg = res.data.all_packages.find(
            (pkg) => pkg.id === res.data?.package?.id
          );

          // ✅ If found, select it; else select the first one
          setSelectedPackage(defaultPkg || res.data.all_packages[0]);

          setParticipantCount({
            adults: Number(defaultPkg.no_of_adult) > 0 ? 1 : 0, // Prefill 1 adult if exists
            children: Number(defaultPkg.no_of_childs) > 0 ? 0 : 0, // Prefill 1 child if exists
            infants: Number(defaultPkg.no_of_infant) > 0 ? 0 : 0, // Prefill 1 infant if exists
          });
        }

        setPrice(res.data);
        setItinerary(res.data.data.itinerary);
        setSlots(res.data.data.slots || []);
      } catch (err) {
        console.error("Error fetching experience details:", err);
      } finally {
        setLoading(false);
      }
    };

    // 🔹 Get initial currency from localStorage or set default
    const getCurrencyId = () => {
      const selectedCurrency = JSON.parse(
        localStorage.getItem("selectedCurrency")
      );
      return selectedCurrency?.id || ""; // using `.id` since your object structure is { id, symbol, ... }
    };

    let currentCurrencyId = getCurrencyId();
    fetchExperienceDetails(currentCurrencyId);

    // 🔹 Listen to changes in localStorage (when updated from any tab)
    const handleStorageChange = (e) => {
      if (e.key === "selectedCurrency") {
        const updatedCurrency = JSON.parse(e.newValue);
        const newCurrencyId = updatedCurrency?.id || "";
        if (newCurrencyId !== currentCurrencyId) {
          currentCurrencyId = newCurrencyId;
          fetchExperienceDetails(newCurrencyId);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // 🔹 Detect same-tab changes (when you setItem manually)
    const localCheck = setInterval(() => {
      const local = getCurrencyId();
      if (local !== currentCurrencyId) {
        currentCurrencyId = local;
        fetchExperienceDetails(local);
      }
    }, 1200); // check every 1.2s

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(localCheck);
    };
  }, [slug, date]);

  useEffect(() => {
    const storedWishlist =
      JSON.parse(localStorage.getItem("userWishlist")) || [];
    if (storedWishlist.includes(Number(experienceData?.data?.experience_id))) {
      setIsWishlisted(true);
    }
  }, [experienceData]);

  // ✅ wishlist handler with login modal trigger

  const handleWishlist = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setLoginOpen(true);
        return;
      }

      const experienceId = experienceData?.data?.experience_id;
      const storedWishlist =
        JSON.parse(localStorage.getItem("userWishlist")) || [];

      // Check if already wishlisted
      if (isWishlisted) {
        // 🔹 Remove from wishlist API
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE}/user/removeFromWishlist`,
          { experience_id: experienceId },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.status) {
          setIsWishlisted(false);
          toast.success("Removed from wishlist!");

          // 🔹 Update localStorage
          const updatedWishlist = storedWishlist.filter(
            (id) => id !== experienceId
          );
          localStorage.setItem("userWishlist", JSON.stringify(updatedWishlist));
        } else {
          toast.error(res.data.message || "Failed to remove from wishlist");
        }
      } else {
        // 🔹 Add to wishlist API
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE}/user/addToWishlist`,
          { experience_id: experienceId },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.status) {
          setIsWishlisted(true);
          toast.success("Added to wishlist!");

          // 🔹 Update localStorage
          if (!storedWishlist.includes(experienceId)) {
            storedWishlist.push(experienceId);
            localStorage.setItem(
              "userWishlist",
              JSON.stringify(storedWishlist)
            );
          }
        } else {
          toast.error(res.data.message || "Failed to add to wishlist");
        }
      }
    } catch (err) {
      console.error("Wishlist error:", err);

      if (err.response?.status === 401) {
        setLoginOpen(true);
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
      } else {
        toast.error(err.response?.data?.message || "Something went wrong");
      }
    }
  };

  // const slotsArray = experienceData?.data?.slots;
  const slotsArray = slots || [];

  const stripHTML = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const calculateTotalPrice = () => {
    if (!selectedPackage) return 0;

    const adultTotal =
      (participantCount.adults || 0) * parseFloat(price?.data?.price || 0);
    const childTotal =
      (participantCount.children || 0) *
      parseFloat(price?.data?.child_price || 0);
    const infantTotal =
      (participantCount.infants || 0) *
      parseFloat(price?.data?.infant_price || 0);

    return adultTotal + childTotal + infantTotal;
  };

  if (loading) {
    // ✅ Full screen skeleton
    return (
      <div className="skeleton-wrapper">
        <div
          className="skeleton"
          style={{ height: "250px", marginBottom: "20px" }}
        ></div>
        <div
          className="skeleton"
          style={{
            height: "20px",
            width: "60%",
            marginBottom: "10px",
          }}
        ></div>
        <div
          className="skeleton"
          style={{
            height: "15px",
            width: "40%",
            marginBottom: "10px",
          }}
        ></div>
        <div
          className="skeleton"
          style={{
            height: "15px",
            width: "80%",
            marginBottom: "10px",
          }}
        ></div>
      </div>
    );
  }

  if (!experienceData || !experienceData.data) {
    return (
      <div className="no-data-found">
        <h3>No data found</h3>
        <p>The requested experience could not be found.</p>
      </div>
    );
  }

  return (
    <>
      <SetMetaTags
        title={experienceData?.data?.meta_title}
        description={experienceData?.data?.meta_description}
        keywords={experienceData?.data?.meta_keyword}
      />

      {/* <!-- Choose Experiences --> */}
      <section class="ser_v_araeea detailspgess">
        <div class="container">
          <div class="row">
            <div class="col-lg-7">
              <div className="products_mgss_bx">
                <ul>
                  {/* {experienceData?.data?.images?.map((img, index) => ( */}
                  {experienceData?.data?.images
                    ?.slice(0, 4)
                    .map((img, index) => (
                      <li
                        key={img.id || index}
                        onClick={() => {
                          // setItineraryImages(experienceData?.data?.itinerary);
                          // setSelectedItineraryIndex(index);
                          setSelectedIndex(index);
                          setImageModalOpen(true);
                        }}
                      >
                        <img
                          src={`${experienceData?.base_url}${img.image}`}
                          alt={`experience-${index}`}
                        />
                      </li>
                    ))}

                  {experienceData?.data?.images?.length > 4 && (
                    <li
                      className="more-images"
                      onClick={() => {
                        setSelectedIndex(0); // 👈 + pe click hote hi 1st image se start
                        setImageModalOpen(true);
                      }}
                    >
                      <div className="adsss_itemss">
                        +{experienceData?.data?.images?.length - 4}
                      </div>
                      {/*<img
						  src={`${experienceData?.base_url}${experienceData?.data?.images[4].image}`}
						  alt="more-images"
						/>*/}
                    </li>
                  )}
                </ul>
              </div>

              {/* <!---- Mobile View Show ----> */}
              <div class="dtls_rightss mb_view_show">
                <div class="titlss_cotnt">
                  <div class="lft_arrra">
                    <h3>{experienceData?.data?.experience_title}</h3>
                    <p>{experienceData?.data?.short_description}</p>
                  </div>
                </div>
                <div class="us_listst">
                  <ul>
                    <li>{experienceData?.data?.rating || 0}/5</li>

                    <li
                      onClick={() => {
                        if (experienceData?.data?.reviews_count > 0) {
                          handleScrollToReviews();
                        }
                      }}
                    >
                      {experienceData?.data?.reviews_count} reviews
                    </li>
                    {/* {experienceData?.data?.city_name && (
                      <li>{experienceData.data.city_name}</li>
						)}*/}
                  </ul>
                </div>

                <div class="thinsto">
                  <div class="tx_box_raeae">
                    <div class="ico_box">
                      <img src="/images/location1.png" alt="" />
                    </div>
                    <div class="txt_sm_ttxtx">
                      {/* <h4>{experienceData?.data?.pickup_point}</h4> */}
                      <p>
                        {experienceData?.data?.city_name}{" "}
                        {experienceData?.data?.country_name}
                      </p>
                    </div>
                  </div>
                  <div class="txt_sm_ttxtx fulss_aea">
                    <p className="red_mro">
                      <TruncateText
                        res={{
                          description: stripHTML(
                            experienceData?.data?.read_more ||
                              "An 8,000 sqft indoor play paradise nestled in the heart of Orchard Cineleisure, SkyPark is designed to provide endless fun and entertainment for children and adults alike. The venue includes multiple play zones, interactive games, and adventure areas suitable for all ages."
                          ),
                        }}
                        maxLength={120}
                      />
                    </p>
                  </div>
                </div>
              </div>
              {/* <!---- End Mobile View Show ----> */}

              <div class="contents_areea">
                {/* <!---- Mobile View Hide ----> */}
                <div className="shedow_booox mb_view_show">
                  <div className="ch_list_ara">
                    <h3>
                      Select Options{" "}
                      <span className="clearss">
                        <button
                          type="button"
                          onClick={() => {
                            if (packages.length > 0) {
                              handlePackageChange(packages[0]);
                            }
                          }}
                        >
                          Clear all
                        </button>
                      </span>
                    </h3>
                    {/* <p>Free Cancellation</p> */}
                  </div>

                  <div className="slt_btns_area">
                    <ul>
                      {packages.map((pkg) => (
                        <li key={pkg.id}>
                          <button
                            type="button"
                            className={
                              selectedPackage?.id === pkg.id ? "actss" : ""
                            }
                            // onClick={() => setSelectedPackage(pkg)}
                            onClick={() => handlePackageChange(pkg)}
                          >
                            {pkg.title}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* --- Quantity --- */}

                  {itineraryLoading ? (
                    <div className="loader-itinerary">
                      <div className="spinner-itinerary"></div>
                      <p>Loading package details...</p>
                    </div>
                  ) : (
                    <>
                      <div className="ch_list_ara">
                        <h3>Quantity</h3>
                        <p>Select the quantity for this package</p>
                      </div>

                      <div className="add_pls_mns quatity_listst">
                        {/* --- Adults --- */}
                        {Number(selectedPackage?.no_of_adult) > 0 && (
                          <div className="main_area_sect">
                            <div className="us_cntens">
                              <p>
                                Adults{" "}
                                <span className="rit_ar">
                                  {experienceData.currency?.currency_symbol}
                                  {Number(price?.data?.price || 0).toFixed(
                                    2
                                  )}{" "}
                                  {experienceData.currency?.currency}
                                </span>
                              </p>
                            </div>
                            <div className="biths_adses">
                              <span
                                className={`addsss ${
                                  participantCount.adults <= 1 ? "disabled" : ""
                                }`}
                                onClick={() =>
                                  handleCountChange("adults", "decrement")
                                }
                              >
                                –
                              </span>
                              <input
                                readOnly
                                className="form-control"
                                type="text"
                                value={participantCount.adults}
                              />
                              <span
                                className={`addsss ${
                                  participantCount.adults >=
                                  selectedPackage?.no_of_adult
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleCountChange("adults", "increment")
                                }
                              >
                                +
                              </span>
                            </div>
                          </div>
                        )}

                        {/* --- Children --- */}
                        {Number(selectedPackage?.no_of_childs) > 0 && (
                          <div className="main_area_sect">
                            <div className="us_cntens">
                              <p>
                                Children{" "}
                                <span className="rit_ar">
                                  {experienceData.currency?.currency_symbol}
                                  {Number(
                                    price?.data?.child_price || 0
                                  ).toFixed(2)}{" "}
                                  {experienceData.currency?.currency}
                                </span>
                              </p>
                            </div>
                            <div className="biths_adses">
                              <span
                                className={`addsss ${
                                  participantCount.children <= 0
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleCountChange("children", "decrement")
                                }
                              >
                                –
                              </span>
                              <input
                                readOnly
                                className="form-control"
                                type="text"
                                value={participantCount.children}
                              />
                              <span
                                className={`addsss ${
                                  participantCount.children >=
                                  selectedPackage?.no_of_childs
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleCountChange("children", "increment")
                                }
                              >
                                +
                              </span>
                            </div>
                          </div>
                        )}

                        {/* --- Infants --- */}
                        {Number(selectedPackage?.no_of_infant) > 0 && (
                          <div className="main_area_sect">
                            <div className="us_cntens">
                              <p>
                                Infants{" "}
                                <span className="rit_ar">
                                  {experienceData.currency?.currency_symbol}
                                  {Number(
                                    price?.data?.infant_price || 0
                                  ).toFixed(2)}{" "}
                                  {experienceData.currency?.currency}
                                </span>
                              </p>
                            </div>
                            <div className="biths_adses">
                              <span
                                className={`addsss ${
                                  participantCount.infants <= 0
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleCountChange("infants", "decrement")
                                }
                              >
                                –
                              </span>
                              <input
                                readOnly
                                className="form-control"
                                type="text"
                                value={participantCount.infants}
                              />
                              <span
                                className={`addsss ${
                                  participantCount.infants >=
                                  selectedPackage?.no_of_infant
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleCountChange("infants", "increment")
                                }
                              >
                                +
                              </span>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* --- End Quantity --- */}

                      <div className="ch_list_ara slots">
                        <h3>
                          Slot
                          {slotsArray && slotsArray.length > 0 && (
                            <div className="rit_showwess">
                              <a onClick={() => setShowModal(true)}>
                                Show All Dates
                              </a>
                            </div>
                          )}
                        </h3>
                        <p>Select the available slot for the package</p>

                        {/* Render dynamic slots */}
                        {/* {slotsArray?.map((slot) => { */}
                        {slotsArray && slotsArray.length > 0 ? (
                          (() => {
                            // ✅ 1. Group slots by date
                            const grouped = slotsArray.reduce((acc, slot) => {
                              const slotDateObj = new Date(slot.slot_date);
                              const weekday = slotDateObj.toLocaleDateString(
                                "en-US",
                                { weekday: "short" }
                              );
                              const monthDay = slotDateObj.toLocaleDateString(
                                "en-US",
                                {
                                  month: "short",
                                  day: "2-digit",
                                }
                              );
                              const dateKey = `${weekday}, ${monthDay}`;
                              if (!acc[dateKey]) acc[dateKey] = [];
                              acc[dateKey].push(slot);
                              return acc;
                            }, {});

                            // ✅ 2. Create a flattened counter for global index
                            let globalIndex = 0;

                            return Object.entries(grouped).map(
                              ([dateKey, groupedSlots], dateIndex) => (
                                <div
                                  key={dateIndex}
                                  className={`slot-group ${
                                    groupedSlots.length > 1 ? "multiadds" : ""
                                  }`}
                                >
                                  <h5 className="lft_txt">{dateKey}</h5>

                                  {groupedSlots.map((slot) => {
                                    const currentIndex = globalIndex++; // unique for every slot

                                    const formatTime = (timeStr) => {
                                      const [hours, minutes] =
                                        timeStr.split(":");
                                      let h = parseInt(hours, 10);
                                      const ampm = h >= 12 ? "pm" : "am";
                                      h = h % 12 || 12;
                                      return `${h}:${minutes}${ampm}`;
                                    };

                                    const now = new Date();
                                    const [hours, minutes, seconds] =
                                      slot.from_time.split(":").map(Number);
                                    const slotDate = new Date(slot.slot_date);
                                    slotDate.setHours(
                                      hours,
                                      minutes,
                                      seconds || 0,
                                      0
                                    );
                                    const isPastSlot =
                                      slotDate.getTime() < now.getTime();

                                    return (
                                      <div className="litssst" key={slot.id}>
                                        <div className="lft_txt">
                                          <p>
                                            {formatTime(slot.from_time)} -{" "}
                                            {formatTime(slot.to_time)}
                                          </p>
                                        </div>

                                        <div className="rits_listst">
                                          {slot.available_pax > 0 ? (
                                            <>
                                              <button
                                                disabled={isPastSlot}
                                                onClick={() => {
                                                  setSelectedSlot(slot);
                                                  setActiveKey(currentIndex);
                                                }}
                                                className={`bttnns ${
                                                  activeKey === currentIndex
                                                    ? "act"
                                                    : ""
                                                } ${
                                                  isPastSlot ? "disabled" : ""
                                                }`}
                                              >
                                                Choose
                                              </button>
                                              <p className="available_txt">
                                                {slot.available_pax} spot
                                                {slot.available_pax > 1
                                                  ? "s"
                                                  : ""}{" "}
                                                left
                                              </p>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                className="bttnns disabled"
                                                disabled
                                              >
                                                Waitlist
                                              </button>
                                              <p className="read_tx">
                                                Sold Out
                                              </p>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )
                            );
                          })()
                        ) : (
                          <p className="error-message">
                            No slot available for today
                          </p>
                        )}

                        <div className="litssst price_datass">
                          <div className="lft_txt">
                            {/* ✅ Show dynamic total only when guests are selected */}
                            <div className="lft_txt">
                              {/* ✅ Show dynamic total only after guests are chosen */}
                              {participantCount.adults +
                                participantCount.children +
                                participantCount.infants >
                              0 ? (
                                <h5>
                                  {experienceData.currency?.currency_symbol}
                                  {calculateTotalPrice().toFixed(2)}{" "}
                                  {experienceData.currency?.currency}{" "}
                                  <span>
                                    for{" "}
                                    {participantCount.adults +
                                      participantCount.children +
                                      participantCount.infants}{" "}
                                    guest
                                    {participantCount.adults +
                                      participantCount.children +
                                      participantCount.infants >
                                    1
                                      ? "s"
                                      : ""}
                                  </span>
                                </h5>
                              ) : (
                                <h5>Select number of guests</h5>
                              )}
                            </div>
                          </div>
                          <div className="rits_listst">
                            {/* <button className="bttnns ">Book Now</button> */}
                            <button
                              className="bttnns"
                              disabled={!selectedSlot}
                              onClick={() => {
                                if (!selectedSlot) {
                                  toast.error("Please select a slot first!");
                                  return;
                                }

                                // ✅ Calculate total guests
                                const totalGuests =
                                  participantCount.adults +
                                  participantCount.children +
                                  participantCount.infants;

                                // ✅ Check against slot availability
                                if (totalGuests > selectedSlot.available_pax) {
                                  toast.error(
                                    `You have selected ${totalGuests} guests, but only ${
                                      selectedSlot.available_pax
                                    } spot${
                                      selectedSlot.available_pax > 1 ? "s" : ""
                                    } left for this slot. Please decrease guest count.`
                                  );
                                  return;
                                }

                                const token = localStorage.getItem("authToken");
                                const today = new Date();
                                const todayFormatted = `${today.getFullYear()}-${String(
                                  today.getMonth() + 1
                                ).padStart(2, "0")}-${String(
                                  today.getDate()
                                ).padStart(2, "0")}`;

                                const user = JSON.parse(
                                  localStorage.getItem("user") || "{}"
                                );

                                // 🧩 Check for host account
                                if (user?.user_type === 2) {
                                  toast.error(
                                    "Looks like you’re using a host account. Please switch to your Experience profile to book this activity."
                                  );
                                  return;
                                }

                                if (user?.signup_complete_status === "0") {
                                  setShowOtherInfoModal(true);
                                  return;
                                }

                                const slotState = {
                                  slotDate:
                                    selectedSlot.slot_date || todayFormatted,
                                  slotDay: selectedSlot.day,
                                  fromTime: selectedSlot.from_time,
                                  toTime: selectedSlot.to_time,
                                  guests: participantCount, // ✅ pass full guest counts
                                  slotDetails: selectedSlot,
                                  totalPrice: calculateTotalPrice(),
                                  packageId: selectedPackage?.id, // ✅ include selected package ID
                                  packageName: selectedPackage?.title,
                                  currencyId: experienceData.currency?.id,
                                  currency: experienceData.currency?.currency,
                                  currency_symbol:
                                    experienceData.currency?.currency_symbol,
                                };

                                if (token) {
                                  navigate(
                                    `/checkout/${experienceData?.data?.url_slug}?slot=${selectedSlot.id}`,
                                    { state: slotState }
                                  );
                                } else {
                                  navigate(
                                    `/confirm/${experienceData?.data?.url_slug}?slot=${selectedSlot.id}`,
                                    { state: slotState }
                                  );
                                }
                              }}
                            >
                              {selectedSlot ? "Book Now" : "Select a Slot"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {/* <!---- End Mobile View Hide ----> */}

                <div class="txt_atar">
                  <h3>About this experience</h3>
                  <p>{experienceData?.data?.about_my_experience}</p>
                </div>

                <div class="txt_atar whaty">
                  <h3>
                    What you’ll do{" "}
                    <a href="#" onClick={toggleShare2} className="mb_view_show">
                      <img
                        src="/images/share-ios.png"
                        class="shr_dwnlr"
                        alt=""
                      />
                    </a>
                  </h3>
                  {showShare2 && (
                    <div className="dtls_rightss">
                      <div className="titlss_cotnt">
                        <Sharepop
                          open={showShare2}
                          onClose={(e) => {
                            e.preventDefault();
                            setShowShare2(false);
                          }}
                          title={experienceData?.data?.experience_title}
                          image={`${experienceData?.base_url}${experienceData?.data?.images?.[0]?.image}`}
                        />
                      </div>
                    </div>
                  )}

                  <ul>
                    {itineraryLoading ? (
                      <li className="loader-itinerary">
                        <div className="spinner-itinerary"></div>
                        <p>Loading itinerary...</p>
                      </li>
                    ) : itinerary && itinerary.length > 0 ? (
                      itinerary.map((item, index) => (
                        <li key={item.id} className={`expert_dtlsss ${
                              item.image ? "" : "datatext_algn"
                            }`}>
                          {item.image && (
                            <div
                              className="activity-image"
                              onClick={() => {
                                // setItineraryImages(itinerary);
                                // setSelectedItineraryIndex(index);
                                const itineraryWithImages = itinerary.filter(item => item.image);
                                setItineraryImages(itineraryWithImages);
                                setSelectedItineraryIndex(
                                  itineraryWithImages.findIndex(i => i.id === item.id)
                                );
                                setItineraryModalOpen(true);
                              }}
                            >
                              <img
                                // src={item.image}
                                src={`${experienceData?.base_url}${item.image}`}
                                alt={item.activity_title || "activity"}
                              />
                            </div>
                          )}
                          <div
                            className={`activity-info ${
                              item.image ? "" : "conten_algn"
                            }`}
                          >
                            <div className="times">
                              {item.activity_time && (
                                <strong>{item.activity_time} </strong>
                              )}
                            </div>
                            <span className="larges">
                              {item.place && <strong>{item.place}</strong>}
                              {item.activity_title && (
                                <span>{item.activity_title}</span>
                              )}
                              {item.duration && (
                                <span> (Duration: {item.duration} mins)</span>
                              )}
                            </span>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className="no-data-found">
                        <p>No itinerary available for this package.</p>
                      </li>
                    )}
                  </ul>
                </div>

                <div class="txt_atar wharer">
                  <h3>Where we’ll meet</h3>
                  <p>
                    {/* {experienceData?.data?.house_no},{" "}
                    {experienceData?.data?.locality},{" "} */}
                    {experienceData?.data?.city_name
                      ? `${experienceData?.data?.city_name}, `
                      : ""}
                    {experienceData?.data?.country_name}
                  </p>

                  <div className="mapss_bx">
                    {/* <iframe
                      src={`https://www.google.com/maps?q=${encodeURIComponent(
                        `
                        
                         ${experienceData?.data?.locality},${experienceData?.data?.city_name}, ${experienceData?.data?.country_name}`
                      )}&output=embed`}
                      width="100%"
                      height="350"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Meeting Location"
                    /> */}
                    <ExperienceMap
                      experienceData={experienceData}
                      house_no={experienceData?.data?.house_no}
                      locality={experienceData?.data?.locality}
                      city={experienceData?.data?.city_name}
                      country={experienceData?.data?.country_name}
                    />
                  </div>
                </div>

                <div class="txt_atar abutss">
                  <h3>About Me</h3>
                  <div class="abt_tx_bx">
                    <div class="usermgss">
                      {/* <img
                        src={`${experienceData?.base_url}${experienceData?.data?.profile_pic}`}
                        alt={`${experienceData?.data?.first_name} ${experienceData?.data?.last_name}`}
                      /> */}
                      <img
                        src={
                          experienceData?.data?.profile_pic
                            ? `${experienceData?.base_url}${experienceData?.data?.profile_pic}`
                            : "/images/user_dh.png"
                        }
                        alt={`${experienceData?.data?.first_name || ""} ${
                          experienceData?.data?.last_name || ""
                        }`}
                      />
                    </div>
                    <div class="contxt_tx_bx">
                      <p>{experienceData?.data?.host_title}</p>
                    </div>
                    <div class="contxt_tx_bx othreenss">
                      <span>{experienceData?.data?.host_about_me} </span>
                      <h6
                        style={{ cursor: "pointer" }}
                        onClick={handleMessageClick}
                      >
                        Message Host
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              {/* <!---- Mobile View Hide ----> */}
              <div class="dtls_rightss mb_view_hide">
                <div class="titlss_cotnt">
                  <div class="lft_arrra">
                    <h3>{experienceData?.data?.experience_title}</h3>

                    <p>{experienceData?.data?.short_description}</p>
                  </div>

                  <div class="ritss_arrra">
                    {/* Share button */}
                    <a href="#" onClick={toggleShare}>
                      <img src="/images/share-ios.png" alt="share" />
                    </a>

                    <a onClick={handleWishlist} style={{ cursor: "pointer" }}>
                      <img
                        src={
                          isWishlisted
                            ? "/images/favourite-filled.png"
                            : "/images/favourite.png"
                        }
                        alt="favourite"
                      />
                    </a>
                  </div>
                  {/* div for share button */}
                  {showShare && (
                    <Sharepop
                      open={showShare}
                      onClose={(e) => {
                        e.preventDefault();
                        setShowShare(false);
                      }}
                      title={experienceData?.data?.experience_title}
                      image={`${experienceData?.base_url}${experienceData?.data?.images?.[0]?.image}`}
                    />
                  )}

                  {/* share button div end */}
                </div>
                <div class="us_listst">
                  <ul>
                    <li>{experienceData?.data?.rating || 0}/5</li>

                    <li
                      className={
                        experienceData?.data?.reviews_count > 0
                          ? ""
                          : "platforma_cursor"
                      }
                      onClick={() => {
                        if (experienceData?.data?.reviews_count > 0) {
                          handleScrollToReviews();
                        }
                      }}
                    >
                      {experienceData?.data?.reviews_count} reviews
                    </li>

                    {/*{experienceData?.data?.city_name && (
                      <li>{experienceData.data.city_name}</li>
                    )}*/}
                  </ul>
                </div>

                <div class="thinsto">
                  <div class="tx_box_raeae">
                    <div class="ico_box">
                      <img src="/images/location1.png" alt="" />
                    </div>
                    <div class="txt_sm_ttxtx">
                      {/* <h4>{experienceData?.data?.city_name}</h4> */}
                      {/* <h4>{experienceData?.data?.pickup_point}</h4> */}
                      <p>
                        {experienceData?.data?.city_name}{" "}
                        {experienceData?.data?.country_name}
                      </p>
                    </div>
                  </div>

                  <div class="txt_sm_ttxtx fulss_aea">
                    <p className="red_mro">
                      <TruncateText
                        res={{
                          description: stripHTML(
                            experienceData?.data?.read_more ||
                              "An 8,000 sqft indoor play paradise nestled in the heart of Orchard Cineleisure, SkyPark is designed to provide endless fun and entertainment for children and adults alike. The venue includes multiple play zones, interactive games, and adventure areas suitable for all ages."
                          ),
                        }}
                        maxLength={120}
                      />
                    </p>
                  </div>
                </div>
              </div>
              {/* <!---- End Mobile View Hide ----> */}

              {/* <!---- Mobile View Hide ----> */}
              <div className="shedow_booox mb_view_hide">
                <div className="ch_list_ara">
                  <h3>
                    Select Options{" "}
                    <span className="clearss">
                      <button
                        type="button"
                        onClick={() => {
                          if (packages.length > 0) {
                            handlePackageChange(packages[0]);
                          }
                        }}
                      >
                        Clear all
                      </button>
                    </span>
                  </h3>
                  {/* <p>Free Cancellation</p> */}
                </div>

                <div className="slt_btns_area">
                  <ul>
                    {packages.map((pkg) => (
                      <li key={pkg.id}>
                        <button
                          type="button"
                          className={
                            selectedPackage?.id === pkg.id ? "actss" : ""
                          }
                          // onClick={() => setSelectedPackage(pkg)}
                          onClick={() => handlePackageChange(pkg)}
                        >
                          {pkg.title}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* --- Quantity --- */}

                {itineraryLoading ? (
                  <div className="loader-itinerary">
                    <div className="spinner-itinerary"></div>
                    <p>Loading package details...</p>
                  </div>
                ) : (
                  <>
                    <div className="ch_list_ara">
                      <h3>Quantity</h3>
                      <p>Select the quantity for this package</p>
                    </div>

                    <div className="add_pls_mns quatity_listst">
                      {/* --- Adults --- */}
                      {Number(selectedPackage?.no_of_adult) > 0 && (
                        <div className="main_area_sect">
                          <div className="us_cntens">
                            <p>
                              Adults{" "}
                              <span className="rit_ar">
                                {experienceData.currency?.currency_symbol}
                                {Number(price?.data?.price || 0).toFixed(
                                  2
                                )}{" "}
                                {experienceData.currency?.currency}
                              </span>
                            </p>
                          </div>
                          <div className="biths_adses">
                            <span
                              className={`addsss ${
                                participantCount.adults <= 1 ? "disabled" : ""
                              }`}
                              onClick={() =>
                                handleCountChange("adults", "decrement")
                              }
                            >
                              –
                            </span>
                            <input
                              readOnly
                              className="form-control"
                              type="text"
                              value={participantCount.adults}
                            />
                            <span
                              className={`addsss ${
                                participantCount.adults >=
                                selectedPackage?.no_of_adult
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() =>
                                handleCountChange("adults", "increment")
                              }
                            >
                              +
                            </span>
                          </div>
                        </div>
                      )}

                      {/* --- Children --- */}
                      {Number(selectedPackage?.no_of_childs) > 0 && (
                        <div className="main_area_sect">
                          <div className="us_cntens">
                            <p>
                              Children{" "}
                              <span className="rit_ar">
                                {experienceData.currency?.currency_symbol}
                                {Number(price?.data?.child_price || 0).toFixed(
                                  2
                                )}{" "}
                                {experienceData.currency?.currency}
                              </span>
                            </p>
                          </div>
                          <div className="biths_adses">
                            <span
                              className={`addsss ${
                                participantCount.children <= 0 ? "disabled" : ""
                              }`}
                              onClick={() =>
                                handleCountChange("children", "decrement")
                              }
                            >
                              –
                            </span>
                            <input
                              readOnly
                              className="form-control"
                              type="text"
                              value={participantCount.children}
                            />
                            <span
                              className={`addsss ${
                                participantCount.children >=
                                selectedPackage?.no_of_childs
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() =>
                                handleCountChange("children", "increment")
                              }
                            >
                              +
                            </span>
                          </div>
                        </div>
                      )}

                      {/* --- Infants --- */}
                      {Number(selectedPackage?.no_of_infant) > 0 && (
                        <div className="main_area_sect">
                          <div className="us_cntens">
                            <p>
                              Infants{" "}
                              <span className="rit_ar">
                                {experienceData.currency?.currency_symbol}
                                {Number(price?.data?.infant_price || 0).toFixed(
                                  2
                                )}{" "}
                                {experienceData.currency?.currency}
                              </span>
                            </p>
                          </div>
                          <div className="biths_adses">
                            <span
                              className={`addsss ${
                                participantCount.infants <= 0 ? "disabled" : ""
                              }`}
                              onClick={() =>
                                handleCountChange("infants", "decrement")
                              }
                            >
                              –
                            </span>
                            <input
                              readOnly
                              className="form-control"
                              type="text"
                              value={participantCount.infants}
                            />
                            <span
                              className={`addsss ${
                                participantCount.infants >=
                                selectedPackage?.no_of_infant
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() =>
                                handleCountChange("infants", "increment")
                              }
                            >
                              +
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* --- End Quantity --- */}

                    <div className="ch_list_ara slots">
                      <h3>
                        Slot
                        {slotsArray && slotsArray.length > 0 && (
                          <div className="rit_showwess">
                            <a onClick={() => setShowModal(true)}>
                              Show All Dates
                            </a>
                          </div>
                        )}
                      </h3>
                      <p>Select the available slot for the package</p>

                      {/* Render dynamic slots */}

                      {slotsArray && slotsArray.length > 0 ? (
                        (() => {
                          // ✅ 1. Group slots by date
                          const grouped = slotsArray.reduce((acc, slot) => {
                            const slotDateObj = new Date(slot.slot_date);
                            const weekday = slotDateObj.toLocaleDateString(
                              "en-US",
                              { weekday: "short" }
                            );
                            const monthDay = slotDateObj.toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "2-digit",
                              }
                            );
                            const dateKey = `${weekday}, ${monthDay}`;
                            if (!acc[dateKey]) acc[dateKey] = [];
                            acc[dateKey].push(slot);
                            return acc;
                          }, {});

                          // ✅ 2. Create a flattened counter for global index
                          let globalIndex = 0;

                          return Object.entries(grouped).map(
                            ([dateKey, groupedSlots], dateIndex) => (
                              <div
                                key={dateIndex}
                                className={`slot-group ${
                                  groupedSlots.length > 1 ? "multiadds" : ""
                                }`}
                              >
                                <h5>{dateKey}</h5>

                                {groupedSlots.map((slot) => {
                                  const currentIndex = globalIndex++; // unique for every slot

                                  const formatTime = (timeStr) => {
                                    const [hours, minutes] = timeStr.split(":");
                                    let h = parseInt(hours, 10);
                                    const ampm = h >= 12 ? "pm" : "am";
                                    h = h % 12 || 12;
                                    return `${h}:${minutes}${ampm}`;
                                  };

                                  const now = new Date();
                                  const [hours, minutes, seconds] =
                                    slot.from_time.split(":").map(Number);
                                  const slotDate = new Date(slot.slot_date);
                                  slotDate.setHours(
                                    hours,
                                    minutes,
                                    seconds || 0,
                                    0
                                  );
                                  const isPastSlot =
                                    slotDate.getTime() < now.getTime();

                                  return (
                                    <div className="litssst" key={slot.id}>
                                      <div className="lft_txt">
                                        <p>
                                          {formatTime(slot.from_time)} -{" "}
                                          {formatTime(slot.to_time)}
                                        </p>
                                      </div>

                                      <div className="rits_listst">
                                        {slot.available_pax > 0 ? (
                                          <>
                                            <button
                                              disabled={isPastSlot}
                                              onClick={() => {
                                                setSelectedSlot(slot);
                                                setActiveKey(currentIndex);
                                              }}
                                              className={`bttnns ${
                                                activeKey === currentIndex
                                                  ? "act"
                                                  : ""
                                              } ${
                                                isPastSlot ? "disabled" : ""
                                              }`}
                                            >
                                              Choose
                                            </button>
                                            <p className="available_txt">
                                              {slot.available_pax} spot
                                              {slot.available_pax > 1
                                                ? "s"
                                                : ""}{" "}
                                              left
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <button
                                              className="bttnns disabled"
                                              disabled
                                            >
                                              Waitlist
                                            </button>
                                            <p className="read_tx">Sold Out</p>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )
                          );
                        })()
                      ) : (
                        <p className="error-message">
                          No slot available for today
                        </p>
                      )}

                      <div className="litssst price_datass">
                        <div className="lft_txt">
                          {/* ✅ Show dynamic total only when guests are selected */}
                          <div className="lft_txt">
                            {/* ✅ Show dynamic total only after guests are chosen */}
                            {participantCount.adults +
                              participantCount.children +
                              participantCount.infants >
                            0 ? (
                              <h5>
                                {experienceData.currency?.currency_symbol}
                                {calculateTotalPrice().toFixed(2)}{" "}
                                {experienceData.currency?.currency}{" "}
                                <span>
                                  for{" "}
                                  {participantCount.adults +
                                    participantCount.children +
                                    participantCount.infants}{" "}
                                  guest
                                  {participantCount.adults +
                                    participantCount.children +
                                    participantCount.infants >
                                  1
                                    ? "s"
                                    : ""}
                                </span>
                              </h5>
                            ) : (
                              <h5>Select number of guests</h5>
                            )}
                          </div>
                        </div>
                        <div className="rits_listst">
                          <button
                            className="bttnns"
                            disabled={!selectedSlot}
                            onClick={() => {
                              if (!selectedSlot) {
                                toast.error("Please select a slot first!");
                                return;
                              }

                              // ✅ Calculate total guests
                              const totalGuests =
                                participantCount.adults +
                                participantCount.children +
                                participantCount.infants;

                              // ✅ Check against slot availability
                              if (totalGuests > selectedSlot.available_pax) {
                                toast.error(
                                  `You have selected ${totalGuests} guests, but only ${
                                    selectedSlot.available_pax
                                  } spot${
                                    selectedSlot.available_pax > 1 ? "s" : ""
                                  } left for this slot. Please decrease guest count.`
                                );
                                return;
                              }

                              if (
                                participantCount.adults +
                                  participantCount.children +
                                  participantCount.infants ===
                                0
                              ) {
                                toast.error(
                                  "Please select at least one guest to continue."
                                );
                                return;
                              }

                              const token = localStorage.getItem("authToken");
                              const today = new Date();
                              const todayFormatted = `${today.getFullYear()}-${String(
                                today.getMonth() + 1
                              ).padStart(2, "0")}-${String(
                                today.getDate()
                              ).padStart(2, "0")}`;

                              const user = JSON.parse(
                                localStorage.getItem("user") || "{}"
                              );

                              // 🧩 Check for host account
                              if (user?.user_type === 2) {
                                toast.error(
                                  "Looks like you’re using a host account. Please switch to your Experience profile to book this activity."
                                );
                                return;
                              }

                              if (user?.signup_complete_status === "0") {
                                // toast.error("Please complete you profile");
                                setShowOtherInfoModal(true);
                                return;
                              }

                              const slotState = {
                                slotDate:
                                  selectedSlot.slot_date || todayFormatted,
                                slotDay: selectedSlot.day,
                                fromTime: selectedSlot.from_time,
                                toTime: selectedSlot.to_time,
                                guests: participantCount, // ✅ pass full guest counts
                                slotDetails: selectedSlot,
                                totalPrice: calculateTotalPrice(),
                                packageId: selectedPackage?.id, // ✅ include selected package ID
                                packageName: selectedPackage?.title,
                                currencyId: experienceData.currency?.id,
                                currency: experienceData.currency?.currency,
                                currency_symbol:
                                  experienceData.currency?.currency_symbol,
                              };

                              if (token) {
                                navigate(
                                  `/checkout/${experienceData?.data?.url_slug}?slot=${selectedSlot.id}`,
                                  { state: slotState }
                                );
                              } else {
                                navigate(
                                  `/confirm/${experienceData?.data?.url_slug}?slot=${selectedSlot.id}`,
                                  { state: slotState }
                                );
                              }
                            }}
                          >
                            {selectedSlot ? "Book Now" : "Select a Slot"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/* <!---- End Mobile View Hide ----> */}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Choose Experiences --> */}

      {/* <!-- Reviews --> */}
      <section
        class="ser_v_araeea manngess pt_top_0 reviewss"
        ref={reviewSectionRef}
      >
        <div class="container hm_arrowss">
          <ReviewSlider
            reviews={experienceData?.data?.reviews}
            baseUrl={experienceData?.base_url}
          />
        </div>
      </section>
      {/* <!-- End Reviews --> */}

      {/* <!-- Things to keep in mind --> */}
      <section class="ser_v_araeea manngess pt_top_0 thinsto">
        {/* <div
          dangerouslySetInnerHTML={{
            __html: experienceData?.data?.keep_in_mind?.trim()
              ? experienceData.data.keep_in_mind
              : cmsData?.data?.content || "",
          }}
        /> */}
        {/* <!-- Things to keep in mind --> */}

       {experienceData?.data?.keep_in_mind &&
experienceData.data.keep_in_mind.length > 0 && (
  <div className="container">
    <div className="al_sec_ctxt mb-2">
      <h2 className="sm_tetx_sizess">Things to keep in mind</h2>
    </div>

    <div className="row">
      {experienceData.data.keep_in_mind.map((item, index) => (
        <div className="col-lg-6" key={index}>
          <div className="tx_box_raeae">
            <div className="ico_box">
              <img
                src={`${experienceData?.base_url}${item.icon}`}
                alt={item.title}
              />
            </div>

            <div className="txt_sm_ttxtx">
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)}


        {/* <div className="container">
  <div className="al_sec_ctxt mb-2">
    <h2 className="sm_tetx_sizess">Things to keep in mind</h2>
  </div>

  <div className="row">
    {experienceData?.data?.keep_in_mind &&
    experienceData.data.keep_in_mind.length > 0 ? (
      experienceData.data.keep_in_mind.map((item, index) => (
        <div className="col-lg-6" key={index}>
          <div className="tx_box_raeae">
            <div className="ico_box">
              <img
                src={`${experienceData?.base_url}${item.icon}`}
                alt={item.title}
              />
            </div>

            <div className="txt_sm_ttxtx">
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      ))
    ) : (
      <p>No information available.</p>
    )}
  </div>
</div> */}

        {/* <!--- Fix Mobile View ---->	 */}
        <div class="shedow_booox fix_positonns">
          <div class="lft_txt">
            <h5>
              {/* From ${experienceData?.data?.price} AUD <span>/ guest</span> */}
              From {experienceData?.currency?.currency_symbol}
              {Number(
                price?.data?.price ||
                  price?.data?.child_price ||
                  price?.data?.infant_price
              ).toFixed(2)}{" "}
              {experienceData?.currency?.currency} <span>/ guest</span>
            </h5>
            {/* <p>Free Cancellation</p> */}
          </div>
          <div class="rits_listst">
            <a onClick={() => setShowModal(true)} class="bttnns">
              Show Dates
            </a>
          </div>
        </div>
        {/* <!--- End Fix Mobile View ---->	 */}
      </section>
      {/* <!-- End Things to keep in mind --> */}

      <LoginModal
        isOpen={loginOpen}
        onClose={() => setLoginOpen(false)}
        userType="1"
      />

      {showOtherInfoModal && (
        <OtherInfo
          isOpen={showOtherInfoModal}
          onClose={closeOtherInfo}
          user={storedUser}
          userType={storedUser?.user_type}
        />
      )}

      <ImageSlider
        isOpen={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        images={experienceData?.data?.images || []}
        baseUrl={experienceData?.base_url}
        total={experienceData?.data?.images?.length}
        startIndex={selectedIndex}
      />

      <ItineraryModal
        open={itineraryModalOpen}
        onClose={() => setItineraryModalOpen(false)}
        images={itineraryImages}
        startIndex={selectedItineraryIndex}
        baseUrl={experienceData?.base_url}
      />

      <ShowdatesModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        slots={slotsArray}
        experienceId={experienceData?.data?.experience_id}
        slug={experienceData?.data?.url_slug}
        hostId={experienceData?.data?.host_id}
        prices={{
          adult: price?.data?.price,
          child: price?.data?.child_price,
          infant: price?.data?.infant_price,
        }}
        price={
          price?.data?.price ||
          price?.data?.child_price ||
          price?.data?.infant_price
        }
        guestType={
          price?.data?.price
            ? "adult"
            : price?.data?.child_price
            ? "child"
            : price?.data?.infant_price
            ? "infant"
            : "adult"
        }
        guest={experienceData?.data?.guest}
        maxLimits={{
          maxAdult: Number(selectedPackage?.no_of_adult) || 0,
          maxChild: Number(selectedPackage?.no_of_childs) || 0,
          maxInfant: Number(selectedPackage?.no_of_infant) || 0,
        }}
        currency={experienceData.currency?.currency}
        currencyId={experienceData.currency?.id}
        currency_symbol={experienceData.currency?.currency_symbol}
        packageId={selectedPackage?.id}
      />
    </>
  );
}

export default ExperienceDetail;
